module.exports = __webpack_public_path__ + "static/media/LU.fd95042b.svg";